const STATUS = {
  1: "Pendente",
  2: "Confirmado",
  3: "Cancelado",
};

const constants = function () {
  if (process.env.NODE_ENV === "production") {
    return {
      TITLE: "Yzzer Admin",
      URL_SERVICE: "https://api.allfast.com.br/api/",
      URL_API: "https://dev.api.allfast.com.br/api",
      // URL_SERVICE: "https://allfast-backend.herokuapp.com/api/",
      //URL_SERVICE: "https://allfast-backend-dev.deway.com.br/api/",
      STATUS,
    };
  }
  return {
    TITLE: "Yzzer Admin DEV",
    URL_SERVICE: "https://api.allfast.com.br/api/",
    URL_API: "https://dev.api.allfast.com.br/api",
    // URL_SERVICE: "https://allfast-backend.herokuapp.com/api/",
    STATUS,
  };
};

export default constants;



// WEBPACK FOOTER //
// ./src/constants.js